/**
 * Maps posgrado malla (Eje, HBCA/HTI) into the grid model used by licenciatura UI.
 */
export function adaptPosgradoMateriasForGrid(materias) {
  return (materias || []).map((m) => ({
    ...m,
    Trayecto: m.Eje,
    SpanTrayectos: m.SpanTrayectos ?? 1,
    Horas: (Number(m.HBCA) || 0) + (Number(m.HTI) || 0),
  }));
}

export function adaptPosgradoMetaForGrid(meta, malla) {
  const semestres = meta?.semestres ?? [];
  const ejes = meta?.ejes ?? [];

  return {
    trayectos: ejes.map((e) => ({ ...e })),
    semestres,
    fases: [
      {
        id: "posgrado-plan",
        label: malla?.Modalidad || "Plan de estudios",
        semestres,
      },
    ],
  };
}

export function isPosgradoMateria(materia) {
  return materia?.Eje != null || materia?.Clave != null;
}
